import * as React from "react";
import ToolbarIcon from "../../../controls/ToolbarIcon";
function ShutdownButton(props) {
    const { t, shutdownPending, activeDownloads, toggleShutdown } = props;
    return (React.createElement(ToolbarIcon, { icon: "onoff", text: t("Power off when done"), className: shutdownPending ? "toolbar-flash-button" : undefined, disabled: !shutdownPending && Object.keys(activeDownloads ?? {}).length === 0, onClick: toggleShutdown }));
}
export default ShutdownButton;
